import { courseSectionTag } from "@/lib/course-section-tag";
import { useTeachingCourses } from "./use-teaching-courses";
import { useLearningCourses } from "./use-learning-courses";

/** Uses the same identity-scoped directory cache as the rail. */
export function useCourseSectionTag(courseId: string, teaching: boolean): string | null {
  const teachingCourses = useTeachingCourses(teaching);
  const learningCourses = useLearningCourses(!teaching);
  const courses = teaching ? teachingCourses.data?.courses : learningCourses.data?.courses;
  return courseSectionTag(courseId, courses ?? []);
}
